import React from 'react'
import { SortableElement } from 'react-sortable-hoc'

import styled from 'styled-components'

import { Form } from 'antd'

import Node from '../../../../../post/Tab.Content/node/parent'
import Title from '../../../../../../components/Field.Text'
import Image from '../../../../../../components/Field.Image'
import Link from '../../../../../../components/Field.Link'

import Caption from '../../../../../../components/Field.Caption'

const Container = styled.div`
    display: flex;

    flex-direction: column;
    flex-wrap: nowrap;

    align-items: flex-start;

    padding: 4px;

    .ant-form-item
    {
        width: 100%;
    }

    .ant-form-item.alt
    {
        margin-bottom: 0;
        padding-bottom: 0;
    }

    ${props => !!props.disabled && `
        pointer-events: none;
        opacity: 0.6;
    `}
`

function Comp (
    {
        action,

        sortIndex,
        length,

        id,
        type,

        image,

        name = '',
        text = '',
        url = '',

        onChange,
        onUploading,

        createTemp,
        disabled,
    }
)
{
    function handleChange (fieldName, fieldValue)
    {
        if (typeof onChange === 'function')
        {
            const old = { id, type, image, url, text }
            onChange ('edit', sortIndex, { ...old, [fieldName]: fieldValue })
        }
    }

    const formLayout = { colon: false }

    return (
        <Node
            title={`รายการที่ ${sortIndex + 1}`}
            action={action}

            index={sortIndex}
            length={length}

            onChange={onChange}
            cols={
                {
                    xs: 24,
                    sm: 12,
                    // md: 8,
                }
            }
        >
            <Form layout="vertical" >
                <Container disabled={!!disabled} >
                    <Image 
                        layout={formLayout}
                        label={null}
                        name="image"
                        value={image}
                        ratio={0.25}
                        fit="contain"
                        disabled={!!disabled}
                        onChange={handleChange}
                        onUploading={onUploading}
                        createTemp={createTemp}
                    />

                    <div style={{ height: 16 }} />

                    <Title 
                        layout={formLayout}
                        disabled={disabled}
                        label="ผู้รีวิว"
                        name="name"
                        value={name}
                        onChange={handleChange}
                    />

                    <Link 
                        layout={formLayout}
                        disabled={disabled}
                        name="url"
                        value={url}
                        onChange={handleChange}
                    />

                    <Caption 
                        id={id}
                        label="ข้อความ"
                        name="text"
                        layout={formLayout}
                        rows={10}
                        minRows={6}
                        maxRows={10}
                        disabled={disabled}
                        value={text}
                        onChange={handleChange}
                    />
                </Container>
            </Form>
        </Node>
    )
}

export default SortableElement(Comp)